import { render, staticRenderFns } from "./PushDeliveryKpisPage.vue?vue&type=template&id=5ec4b88a&"
import script from "./PushDeliveryKpisPage.vue?vue&type=script&lang=js&"
export * from "./PushDeliveryKpisPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports